export const CATEGORIES = [
  { key: "medical", label: "Medical" },
  { key: "education", label: "Education" },
  { key: "food", label: "Food & Ration" },
  { key: "shelter", label: "Shelter & Housing" },
  { key: "livelihood", label: "Livelihood & Business" },
  { key: "other", label: "Other" },
];

export const HELP_TYPES = [
  { key: "money", label: "Money" },
  { key: "goods", label: "Goods / Supplies" },
  { key: "service", label: "Service / Time" },
  { key: "other", label: "Other" },
];

// Turns a YouTube / Vimeo page link into an embeddable player URL; anything else returns null.
export function embedUrl(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, "");
    if (host === "youtu.be") return `https://www.youtube.com/embed/${u.pathname.slice(1)}`;
    if (host === "youtube.com" || host === "m.youtube.com") {
      const id = u.searchParams.get("v") || (u.pathname.startsWith("/embed/") ? u.pathname.split("/")[2] : null);
      return id ? `https://www.youtube.com/embed/${id}` : null;
    }
    if (host === "vimeo.com") {
      const id = u.pathname.split("/").filter(Boolean)[0];
      return id ? `https://player.vimeo.com/video/${id}` : null;
    }
  } catch {
    /* not a URL */
  }
  return null;
}
